import { useEffect, useState } from "react";
import { useField } from "@formily/react";
import { useStateMachine } from "little-state-machine";
import { IRumbleFormScope } from ".";
import { Select } from "./Select";

export interface IRumbleCompaniesSelectProps {
  type?: string;
  [key: string]: any;
}

export const RumbleCompaniesSelect: React.FC<IRumbleCompaniesSelectProps> = (
  props,
) => {
  const field = useField();
  const { state } = useStateMachine();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<unknown>(null);

  // Safely extract scope and fetchData
  const scope = (state as { scope?: IRumbleFormScope }).scope;
  const fetchData = scope?.fetchData;
  if (!fetchData) {
    throw new Error("fetchData function is not available");
  }

  useEffect(() => {
    const loadOptions = async () => {
      const queryParameters: any = {
        pagination: false,
        type: props?.type ?? "insurance",
      };

      if (props?.servicePartnerId) {
        queryParameters["servicePartners.id"] = props?.servicePartnerId;
      }

      try {
        const response = await fetchData({
          endpoint: `/companies`,
          queryParameters,
        });
        const options = response.data.map(
          (insuranceCompany: { [key: string]: any }) => ({
            value: insuranceCompany["@id"],
            label: insuranceCompany.name,
          }),
        );

        field.setComponentProps({ options });
        setError(null);
      } catch (error) {
        setError(error);
        if (props.onError) props.onError(error);
        console.error("Failed to load options", error);
      } finally {
        setLoading(false);
      }
    };

    loadOptions();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [field, props.type]);

  if (error) {
    return <div style={{ color: "red" }}>Failed to load companies.</div>;
  }

  return <Select loading={loading} {...props} />;
};

export default RumbleCompaniesSelect;
